import { gql } from '@apollo/client';

export const TOGGLE_FORM_VISIBILITY = gql`
  mutation toggleFormVisibility($id: ID!, $input: ToggleFormVisibilityInput!) {
    toggleFormVisibility(id: $id, input: $input) {
      id
      title
    }
  }
`;